export const HOME = {
  emergentLink: 'emergent-link',
}

export const HEADER = {
  container: 'header-container',
  logo: 'header-logo',
  nav: 'header-nav',
  navSobreMi: 'nav-sobre-mi',
  navProyectos: 'nav-proyectos',
  navContacto: 'nav-contacto',
  navHablemos: 'nav-hablemos',
}

export const HERO = {
  section: 'hero-section',
  photo: 'hero-photo',
  textLine1: 'hero-text-line1',
  textLine2: 'hero-text-line2',
  scrollIndicator: 'hero-scroll-indicator',
}

export const SOBRE_MI = {
  section: 'sobre-mi-section',
  bio: 'sobre-mi-bio',
  cta: 'sobre-mi-cta',
}

export const PROYECTOS = {
  section: 'proyectos-section',
  grid: 'proyectos-grid',
  card: (id) => `proyecto-card-${id}`,
}

export const CONTACTO = {
  section: 'contacto-section',
  form: 'contact-form',
  nameInput: 'contact-name-input',
  emailInput: 'contact-email-input',
  messageInput: 'contact-message-input',
  submitButton: 'contact-submit-button',
  successMessage: 'contact-success-message',
  errorMessage: 'contact-error-message',
}
